import { queryAll, query, fromId } from '../utils/utils.js';


export class ComplexTabsBlock {

	constructor() {
        console.log( '[BHS] - Complex Tabs Block' );

        queryAll( '.complex-tabs-block' ).forEach( ( block , i ) => {
            block.dataset.blockid = i;
			console.log( block.dataset.blockid );
            this.initTabsBlock( block );
        });
	}

    initTabsBlock(block) {

        const blockID = block.dataset.blockid;
		const navItems = block.querySelector( '.internal-nav .nav-items' );
		if(navItems !== null){
			navItems.innerHTML = "";
			block.querySelectorAll( '.content-row .content-groups-col .nav-content' ).forEach( ( group , i ) => {
				navItems.innerHTML += `<div class="nav-item">${group.innerHTML}</div>`;
			});
			console.log(block.querySelector( '.internal-nav .nav-item:first-child'));


			const tabs = block.querySelectorAll( '.internal-nav .nav-item a' );

			if( tabs ) {
				tabs.forEach( tab => {
					tab.addEventListener( 'click', e => {
						e.preventDefault();
						this.toggleContent( blockID , e.currentTarget.dataset.group , 1 );
						block.querySelector( '.content-group.active .group-nav .nav-item:first-child a')?.click();
					});
				});
			}
			//activate the first tab
			block.querySelector( '.internal-nav .nav-item:first-child a')?.click();
		}else{
			//no nav make everything render
			block.querySelectorAll( '.content-group')?.forEach((group, i) => {
				group?.classList.add( 'active' );
			});
		}


		//setup the internal nav
		queryAll('.content-groups-col').forEach( ( innerBlock , i ) => {
			const innerNavItems = innerBlock.querySelector( '.group-nav .nav' );
			if(innerNavItems !== null){
				innerNavItems.innerHTML = "";
				innerBlock.querySelectorAll( '.inner-nav-content' ).forEach( ( group , i ) => {
					innerNavItems.innerHTML += `<li class="complex-nav-item">${group.innerHTML}</li>`;
					//mobile content
					innerNavItems.innerHTML += `<div class="group-content group-content-hidden" data-content="${group.querySelector('a').dataset.content}"></div>`;
				});
			}
		});

		//inner nav click events
        block.querySelectorAll('.content-group').forEach( ( group , i ) => {
            const groupID = group.dataset.group;
            group.querySelectorAll( '.group-nav .complex-nav-item a' ).forEach( ( contentNavItem , j ) => {
                contentNavItem.addEventListener( 'click', e => {
                    e.preventDefault();
                    this.toggleContent(blockID, groupID, e.currentTarget.dataset.content );
                });
            });
        } );
		block.querySelector( '.content-group.active .group-nav .complex-nav-item:first-child a')?.click();
    }

    toggleContent( blockID , groupID , contentID ) {

        const block = query( `.complex-tabs-block[data-blockid="${blockID}"]` );
        const tabs = block.querySelectorAll( '.internal-nav .nav-item a' );
        const groups = block.querySelectorAll( '.content-group' );

        if( tabs ) {
            tabs.forEach( tab => {
                if( tab.dataset.group == groupID ) {
                    tab.classList.add( 'active' );
                } else {
                    tab.classList.remove('active');
                }
            });
        }

        if (groups ) {
            groups.forEach( group => {
                if( group.dataset.group == groupID ) {
                    group.classList.add( 'active' );
                } else {
                    group.classList.remove('active');
                }

				let activeContent = "";

                const content = group.querySelectorAll( '.group-content .content-item' );
                const groupNav = group.querySelectorAll( '.group-nav .complex-nav-item a' );
				const mobileGroupContent = group.querySelectorAll( '.group-content-hidden' );

                if( content ) {
                    content.forEach( contentItem => {
                        if( contentItem.dataset.content == contentID ) {
                            contentItem.classList.add( 'active' );
							activeContent = contentItem.parentElement.innerHTML;
                        } else {
                            contentItem.classList.remove('active');
                        }
                    });
                }

                if( groupNav ) {
                    groupNav.forEach( navItem => {
                        if( navItem.dataset.content == contentID ) {
                            navItem.classList.add( 'active' );
							// navItem.parentElement.parentElement.querySelector('.group-content-hidden').innerHTML = activeContent;
							// navItem.parentElement.parentElement.querySelector('.group-content-hidden').classList.add('active');
                        } else {
                            navItem.classList.remove('active');
                        }
                    });
                }

				if(window.innerWidth <= 768){
					if( mobileGroupContent ) {
						mobileGroupContent.forEach( mobileGroupItem => {
							if( mobileGroupItem.dataset.content == contentID ) {
								if(mobileGroupItem.classList.contains('active')){
									mobileGroupItem.classList.remove( 'active' );
									//remove active from group nav also
									if( groupNav ) {
										groupNav.forEach( navItem => {
											navItem.classList.remove('active');
										});
									}
								}else{
									mobileGroupItem.classList.add( 'active' );
									// setTimeout(function(){
									// 	let offset = 0;
									// 	if(document.querySelector('.interior-nav')){
									// 		offset = document.querySelector('.interior-nav').offsetHeight;
									// 	}
									// 	console.log(offset);
									// 	mobileGroupItem.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', offsetTop: offset});
									// }, 500);
								}
								mobileGroupItem.innerHTML = activeContent;
								mobileGroupItem.querySelector('.group-nav .complex-nav-item:first-child a')?.click();
							} else {
								mobileGroupItem.classList.remove('active');
							}
						});
					}
				}


			});
        }



    }

}
